import { Helmet } from 'react-helmet-async';
import { ComparisonTool } from './comparison-tool';

/**
 * Route entry point for the Comparison Tool page.
 * @return {JSX.Element} The comparison tool page
 */
export function ComparisonToolPage() {
  return (
    <>
      <Helmet>
        <title>Comparison Tool</title>
      </Helmet>
      <ComparisonTool />
    </>
  );
}
